import { LockInfo } from 'src/models/common/LockInfo';
import { CalculationTemplateMetaData } from 'src/models/calculation-builder/CalculationTemplate';
import CONSTANTS from 'src/utils/constants';

/**
 * Derives the VIEW_MODE value from lock state.
 * If lockInfo is null/undefined (backend doesn't return it or hasn't loaded yet),
 * treats as not locked → READ_ONLY (safe default, Edit button will be enabled).
 */
export function deriveViewModeFromLockInfo(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): string {
    if (!lockInfo || !lockInfo.isLocked) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }
    if (currentUser && lockInfo.lockedBy === currentUser) {
        return CONSTANTS.VIEW_MODE.EDITABLE;
    }
    return CONSTANTS.VIEW_MODE.READ_ONLY;
}

/**
 * Returns true if the entity is locked by a user other than the current user.
 * Used to show the lock banner and disable the Edit button.
 * Returns false if lockInfo is null/undefined (graceful degradation).
 */
/**
 * Derives the effective viewMode for template-linked CLIs.
 * When a CLI is linked to a template and the user is not editing the template,
 * EDITABLE should be downgraded to TEMPLATE_READ_ONLY to prevent structural edits.
 */
export function getEffectiveViewMode(
    viewMode: string | undefined,
    calculationTemplateMetaData: CalculationTemplateMetaData | null | undefined,
    isEditingTemplate: boolean
): string | undefined {
    const isTemplateLocked = calculationTemplateMetaData?.templateId != null && !isEditingTemplate;
    if (isTemplateLocked && viewMode === CONSTANTS.VIEW_MODE.EDITABLE) {
        return CONSTANTS.VIEW_MODE.TEMPLATE_READ_ONLY;
    }
    return viewMode;
}

export function isLockedByOther(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): boolean {
    if (!lockInfo || !lockInfo.isLocked) {
        return false;
    }
    return lockInfo.lockedBy !== currentUser;
}
